import React from "react"
import PropTypes from "prop-types"
import styled from "react-emotion"

const ErrorWrap = styled("div")`
  color: #92999f;
  font-size: 12px;
  .error {
    font-size: 3em;
  }
`

const MediaFailed = ({ text }) => (
  <ErrorWrap className='center'>
    <div className='material-icons grey error'>error</div>
    <div className='bold'>{text}</div>
  </ErrorWrap>
)

MediaFailed.defaultProps = {
  text: "Error Reading File"
}

MediaFailed.propTypes = {
  text: PropTypes.string
}

export default MediaFailed
